import { createContext, useContext, useEffect, useState } from 'react';

import { getAccountUrl, getSessionData } from '../../services/schibstedAccount';
import { config } from '../../config';

import { getUserFullName, getUserInitials } from './helpers';

import type { HasSessionSuccessResponse } from '@schibsted/account-sdk-browser/src/identity';
import type { FC } from 'react';

interface Identity {
  isLoggedIn: boolean;
  sessionData: HasSessionSuccessResponse | null;
  initials: string;
  fullName: string;
  accountUrl: string;
  clientId?: string;
}

const IdentityContext = createContext<Identity>(undefined!);

const initialState = {
  isLoggedIn: false,
  sessionData: null,
  initials: '',
  fullName: '',
  accountUrl: '',
} as Identity;

export const IdentityProvider: FC = ({ children }) => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    (async () => {
      // .getSessionData() shouldn't throw
      const sessionData = await getSessionData();

      if (!sessionData) {
        return;
      }

      if ('result' in sessionData) {
        setState({
          sessionData,
          isLoggedIn: true,
          initials: getUserInitials(sessionData),
          fullName: getUserFullName(sessionData),
          accountUrl: await getAccountUrl(),
          clientId: config.schibstedAccount.clientId,
        });
      }
    })();
  }, []);

  return (
    <IdentityContext.Provider value={state}>
      {children}
    </IdentityContext.Provider>
  );
};

export const useIdentity = () => useContext(IdentityContext) ?? initialState;
